import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dfebe5ca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=dfebe5ca&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfebe5ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfebe5ca')) {
      api.createRecord('dfebe5ca', component.options)
    } else {
      api.reload('dfebe5ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dfebe5ca&scoped=true&", function () {
      api.rerender('dfebe5ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/billDetail/index.vue"
export default component.exports